import React from 'react';
import { styled } from 'styled-components';

const Title = styled.p`
    font-size: 3rem;
    text-align: center;
    color: ${({theme}) => theme.colors.primary};
    letter-spacing: 0.25rem;
    padding: 3rem;
    margin-bottom: 1rem;
`;

export default Title;
